import { useSelector } from 'react-redux';

/**
 * Custom hook to access company data from Redux store
 * @returns {Object} Company data including id, name, email, phone, address
 */
export const useCompany = () => {
    const company = useSelector((state) => state.auth.company);

    return {
        company,
        companyId: company?.id || null,
        companyName: company?.name || null,
        companyEmail: company?.email || null,
        companyPhone: company?.phone || null,
        companyAddress: company?.address || null,
    };
};

/**
 * Custom hook to access user with company information
 * @returns {Object} User data with companyId and company tax/service charge details
 */
export const useUserWithCompany = () => {
    const user = useSelector((state) => state.auth.user);
    const company = useSelector((state) => state.auth.company);

    // Debug logging
    console.log('useUserWithCompany - Raw company data:', company);
    console.log('useUserWithCompany - vatRate:', company?.vatRate);
    console.log('useUserWithCompany - serviceChargeRateDining:', company?.serviceChargeRateDining);
    console.log('useUserWithCompany - serviceChargeRateTakeaway:', company?.serviceChargeRateTakeaway);

    return {
        user,
        company,
        companyId: user?.companyId || company?.id || null,
        userType: user?.type || null,
        userStatus: user?.status || null,
        // Company financial details
        vatRate: parseFloat(company?.vatRate || 0),
        taxId: company?.taxId || null,
        serviceChargeRateDining: parseFloat(company?.serviceChargeRateDining || 0),
        serviceChargeRateTakeaway: parseFloat(company?.serviceChargeRateTakeaway || 0),
        serviceChargeRateDelivery: parseFloat(company?.serviceChargeRateDelivery || 0),
        currency: company?.currency || 'LKR',
    };
};

export default useCompany;
